module.exports = __webpack_public_path__ + "static/media/admin_console-roster.12aa5e4c.png";